import { request } from '../client'
import type {
  AdminLoginRequest,
  AdminLoginResponse,
  LoginRequest,
  LoginResponse,
  ScoreLoginChallenge,
  ScoreVerifySuccess,
  SessionStatus,
} from '../types'

export function clubLogin(body: LoginRequest): Promise<LoginResponse> {
  return request<LoginResponse>('/auth/login', {
    method: 'POST',
    body,
  })
}

export function checkClubSession(tokens: {
  accessToken: string
  providerSession: string
}): Promise<SessionStatus> {
  return request<SessionStatus>('/auth/session', {
    auth: {
      accessToken: tokens.accessToken,
      providerSession: tokens.providerSession,
    },
  })
}

export function scoreStartLogin(body: {
  username: string
  password: string
}): Promise<ScoreLoginChallenge> {
  return request<ScoreLoginChallenge>('/auth/score/session', {
    method: 'POST',
    body,
  })
}

export function scoreVerifyChallenge(body: {
  challenge_token: string
  code: string
}): Promise<ScoreVerifySuccess> {
  return request<ScoreVerifySuccess>('/auth/score/session/verify', {
    method: 'POST',
    body,
  })
}

export function adminLogin(
  body: AdminLoginRequest,
): Promise<AdminLoginResponse> {
  return request<AdminLoginResponse>('/auth/admin/login', {
    method: 'POST',
    body,
  })
}
